<svelte:options
  customElement={{
    tag: "hopper-auction-cinema-v1",
    shadow: "none",
    props: {
      variationId: { type: "String", attribute: "variation-id" },
      eventMergeId: { type: "String", attribute: "event-merge-id" },
    },
  }}
/>

<script lang="ts">
  import SpaCinema from "./spa-cinema/SpaCinema.svelte";
  import SpaCinemaHeader from "./spa-cinema-header/SpaCinemaHeader.svelte";
  import {fetchCinemaProducts} from "./lib/CinemaService";
  import type {CinemaProps} from "./index";
  import type {CinemaDataDto} from "./types/CinemaProductsDto.types";
  import DsaSheet from "./dsa-sheet/DsaSheet.svelte";
  import {logError} from "../logger.ts";

  const {variationId, eventMergeId}: CinemaProps = $props();
  let cinemaData = $state<CinemaDataDto | undefined>(undefined);
  let allProductTilesFailed = $state(false);
  const cinemaDataToShow = $derived(
    (cinemaData?.cinemaSponsoredProducts.length ?? 0) > 0 &&
    !allProductTilesFailed
      ? cinemaData
      : undefined,
  );

  $effect(() => {
    if (!variationId) {
      logError(Error("Cinema: variationId is required"));
      return;
    }

    fetchCinemaProducts(variationId).then(([err, res]) => {
      if (err) {
        return logError(err);
      }
      cinemaData = res;
    });
  });

  let dsaSheet: DsaSheet | undefined = $state();

  function openDsaSheet() {
    dsaSheet?.open();
  }
</script>

<div class="spa-cinema-component">
  {#if cinemaDataToShow}
    <div class="cinema-container"
         class:clean-tiles={cinemaDataToShow.useCleanTiles}
         class:legacy-container={!cinemaDataToShow.useCleanTiles}>
      <SpaCinemaHeader
        variations={cinemaDataToShow.cinemaSponsoredProducts}
        onDsaClick={openDsaSheet}
      />
      <SpaCinema
        auctionId={cinemaDataToShow.auctionId}
        variations={cinemaDataToShow.cinemaSponsoredProducts}
        cinemaTrackingLabels={cinemaDataToShow.cinemaTrackingLabels}
        useOfcPricingItem={cinemaDataToShow.useOfcPricingItem}
        useOfcWishlistSaveButton={cinemaDataToShow.useOfcWishlistSaveButton}
        useCleanTiles={cinemaDataToShow.useCleanTiles}
        {eventMergeId}
        onAllProductTilesFailed={() => (allProductTilesFailed = true)}
      />
    </div>

    <DsaSheet
      bind:this={dsaSheet}
      variations={cinemaDataToShow.cinemaSponsoredProducts}
    />
  {/if}
</div>

<style lang="scss">
  @use "@otto-ec/design-tokens/tokens";

  .cinema-container {
    display: flex;
    flex-direction: column;
    container-type: inline-size;

    &.legacy-container {
      margin-bottom: tokens.$oc-semantic-spacing-150;
    }

    &.clean-tiles {
      background-color: tokens.$oc-base-color-white-100;
      padding-bottom: tokens.$oc-semantic-spacing-150;
    }
  }

</style>
